
import React, { useEffect, useState } from 'react'
import closeIcon from '../../../assets/images/Icons/close_icon.svg'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarIcon from "../../../assets/images/Icons/calendarIcon.svg";
import DownArrow from "../../../../src/assets/images/Icons/icons/down_arrow.svg";
import UpArrow from "../../../../src/assets/images/Icons/icons/up_arrow.svg";
import { makeAjax, respStatus, url, showMessage } from '../../../helpers/global_helper';
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { formatPrice } from "../../NumberFormat";
import InvoiceTogleBetPopup from '../../Header/HeaderRightMenu/InfoSubComponents/InvoiceTogleBetPopup';
import StatementWinPopup from "../../Header/HeaderRightMenu/InfoSubComponents/StatementWinPopup";
import { useNavigate } from "react-router-dom";
import LeftArrow from "../../../assets/images/Icons/icons/left_arrow.svg";
import { MdOutlineArrowBackIos } from "react-icons/md";
import { FaCalendar } from "react-icons/fa";

const StatementMoDesign = () => {

  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(new Date());
  const [selectGameName, setSelectGameName] = useState("Combodia");
  const [gameName, setGameName] = useState([]);
  const pageNumber = useSelector((state) => state.paginationData.pageNumber)
  const perPage = useSelector((state) => state.paginationData.dataInOnePage)
  const [transectionData, setTransectionData] = useState([]);
  const [showBetPopup, setBetShowPopup] = useState(false);
  const [showWinStatmentPopup, setWinStatementPopup] = useState(false);
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [totalData, setTotalData] = useState([]);
  const [win, setWin] = useState("");
  const [subgame, setSubgame] = useState("");

  const date = new Date(startDate);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to month because it's zero-indexed
  const day = date.getDate().toString().padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  // api for Game list
  const featchGameList = () => {
    makeAjax(url.TOGEL_API.listGame).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setGameName(response.data);
    });
  };
  useEffect(() => {
    featchGameList();
  }, []);
  useEffect(() => {
    featchTransectionList();
    const container = document.querySelector('.informasi_tble_result');
    if (container) {
      container.scrollTop = 0;
    }
  }, [perPage, pageNumber]);

  const featchTransectionList = () => {
    setLoading(true)
    let reqData = {
      // page: pageNumber,
      date: formattedDate,
      game_id: selectGameName == "Combodia" ? 202 : parseInt(selectGameName),
      // date: "2024-05-28",
      // game_id: 201,
      // length: perPage,
    };
    makeAjax(url.TOGEL_API.listInvoiceTogelData, reqData).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setTotalData(response.data)

      setTransectionData(response.data.list_subgame);
      setLoading(false)
    });
  }
  const CustomInput = ({ value, onClick }) => (
    <div style={{ position: "relative" }} className="custom_calendar">
      <input
        type="text"
        value={value}
        onClick={onClick} // This opens the calendar on input click
        readOnly // Prevent direct text input
      />
      <button
        onClick={onClick} // This also opens the calendar on icon click

        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {/* <img src={CalendarIcon} alt="" /> */}
        <FaCalendar />
      </button>
    </div>
  );
  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const sortedData = () => {
    if (sortBy === "buy" || sortBy === "pay") {
      return transectionData.slice().sort((a, b) => {
        const aValue = parseFloat(a[sortBy]);
        const bValue = parseFloat(b[sortBy]);
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy === "pay" || sortBy === "win") {
      return transectionData.slice().sort((a, b) => {
        const aValue = parseFloat(a[sortBy]);
        const bValue = parseFloat(b[sortBy]);
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy) {
      return transectionData.slice().sort((a, b) => {
        const aValue = a[sortBy].toLowerCase();
        const bValue = b[sortBy].toLowerCase();
        return sortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      });
    }
    return transectionData;
  };

  const handleGameSelectOptions = (e) => {
    const selectedValue = e.target.value;
    setSelectGameName(selectedValue);
  };
  const handleSearchData = () => {
    const container = document.querySelector('.informasi_tble_result');
    if (container) {
      container.scrollTop = 0;
    }
    featchTransectionList();
  };
  const closeInvoiceTogelPopup = () => {
    setBetShowPopup(false);
  };
  const closeWinStatementPopup = () => {
    setWinStatementPopup(false);
  };
  const handleInvoiceToglePopup = (win, subgame) => {
    setWin(win);
    setSubgame(subgame)
    setBetShowPopup(true);
  };
  const handleStatementWinToglePopup = (win, subgame) => {
    setWin(win);
    setSubgame(subgame);
    setWinStatementPopup(true);
  }
  return (
    <div className="main_contain information_mo">
      <div className="pages_topbar">
        <div className="back_arrow" onClick={() => navigate("/")}>
          {/* <img src={LeftArrow}></img> */}
          <MdOutlineArrowBackIos />

        </div>
        <div className="page_heading">
          <h2>Statement</h2>
        </div>
      </div>
      <div className="trasaction_top_bar statement_top_bar">
        <div className="calendar">
          <DatePicker
            // showIcon
            customInput={<CustomInput />}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            maxDate={new Date()}
          />
        </div>
        <div className="all_game_dropdown">
          <select
            className="dropdown"
            value={selectGameName}
            onChange={handleGameSelectOptions}
          >
            {gameName.length > 0 &&
              gameName.map(({ game_id, game_name }) => (
                <option key={game_id} value={game_id}>
                  {game_name}
                </option>
              ))}
          </select>
        </div>
        <div className="search">
          <button onClick={handleSearchData}>Search</button>
        </div>
      </div>
      {/* table */}
      <div className="informasi_tble_result statement_tble_result">
        <table>
          <thead>
            <tr>
              <th>No.</th>
              <th>Game</th>
              <th onClick={() => handleSort("buy")}>
                Buy
                <span className="sorting_arrow">
                  <img
                    src={
                      sortBy === "buy" && sortOrder === "asc"
                        ? UpArrow
                        : DownArrow
                    }
                    alt=""
                  />
                </span>
              </th>
              <th onClick={() => handleSort("pay")}>
                Pay
                <span className="sorting_arrow">
                  <img
                    src={
                      sortBy === "pay" && sortOrder === "asc"
                        ? UpArrow
                        : DownArrow
                    }
                    alt=""
                  />
                </span>
              </th>
              <th onClick={() => handleSort("win")}>
                Total Win
                <span className="sorting_arrow">
                  <img
                    src={
                      sortBy === "win" && sortOrder === "asc"
                        ? UpArrow
                        : DownArrow
                    }
                    alt=""
                  />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              (sortedData().length === 0 ? (
                <tr className="table_data_empty_row ">
                  <td colSpan="5">data_not_found</td>
                </tr>
              ) : (
                sortedData().map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      <td>{index + 1}</td>
                      <td>
                        <span
                          className="link"
                          onClick={() =>
                            handleInvoiceToglePopup(item.win, item.subgame)
                          }
                        >
                          {item.name}
                        </span>
                      </td>
                      <td>{item.buy}</td>
                      <td>{item.pay}</td>
                      <td>
                        <span className="total_count link"
                        onClick={() =>
                          handleStatementWinToglePopup(item.win, item.subgame)
                        }>{item.win}</span>
                      </td>
                    </tr>
                  );
                })
              ))}
            <tr>
              <td colSpan={2}> Total</td>
              <td>{totalData.totalBuy}</td>
              <td>{totalData.totalPay}</td>
              <td>{totalData.totalWin}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {showBetPopup && (
        <InvoiceTogleBetPopup
          onClose={closeInvoiceTogelPopup}
          gameid={totalData.gameId}
          period={totalData.period}
          act={win}
          subgame={subgame}
        />
      )}
      {showWinStatmentPopup && (
            <StatementWinPopup
              onClose={closeWinStatementPopup}
              gameid={totalData.gameId}
              period={totalData.period}
              act={win}
              subgame={subgame}
            />
          )}
    </div>
  );
}

export default StatementMoDesign